<div class="container-fluid">
	<div class="mb-2 mx-2">
		<span class="h5 mb-0">
			ANR M&amp;P Academics
		</span>
		<button
			class="btn btn-primary btn-sm"
			(click)="openNewAcademicModal()">
				+ Add an Academic
		</button>

		<button mat-button class="btn btn-primary btn-sm ml-2" [matMenuTriggerFor]="menu">Reports</button>
		<mat-menu #menu="matMenu">
			<button mat-menu-item
				(click)="exportAcademicsToExcel()">
				Export Academics
			</button>		
			<button mat-menu-item
				(click)="exportCaseReportToExcel()">
				Case Report
			</button>	
			<button mat-menu-item
				(click)="exportEligibilityListToExcel()">
				Eligibility List
				<i class="fa fa-info-circle ml-1 text-muted"
					matTooltip="Export results reflect the filters currently applied on this page" 
					matTooltipPosition="right"></i>
			</button>	
			<button mat-menu-item
				(click)="exportFileDownloadEventToExcel()">
				File Download Event
			</button>
		</mat-menu>

		<div style="float:right;">
			<button
				class="btn btn-secondary btn-sm ml-1"
				(click)="openProgressionTableWorkshopModal()">
					View progression tables
			</button>

			<button
				class="btn btn-secondary btn-sm ml-1"
				(click)="openReviewRequirementsWorkshopModal()">
					View review requirements
			</button>
		</div>
	</div>

	<hr>

	<div class="d-flex justify-content-between align-items-center mb-2 mx-2" [formGroup]="filterForm">
		<span class="text-muted text-sm">Showing {{cases.length}} of {{allCases.length}}</span>
		<div class="form-check">
			<input class="form-check-input" type="checkbox" id="needsReconciliationOnly" formControlName="needsReconciliationOnly">
			<label class="form-check-label" for="needsReconciliationOnly">Needs reconciliation only</label>
		</div>
		<button (click)="resetFilters()" class="btn btn-sm btn-secondary">Reset Filters</button>
	</div>

	<!-- Combined table header + filters -->
	<div class="list-group" [formGroup]="filterForm">
		<div class="list-group-item py-1" style="border:none; background:none; border-bottom: 1px solid #ccc;">
			<div class="row text-sm">
				<div class="col-md-2 column-title">
					<sort-column-header
						[column]="sortColumns.name"
						[(currentSorting)]="currentSorting"></sort-column-header>
					<input type="text"
						placeholder="Filter by name"
						class="form-control form-control-sm form-control-original mt-1"
						formControlName="userName"
						[autofocus]>
				</div>
				<div class="col-md-3 column-title">
					<sort-column-header
						[column]="sortColumns.position"
						[(currentSorting)]="currentSorting"></sort-column-header>
					<select formControlName="currentPositionHid" class="form-control form-control-sm form-control-original mt-1">
						<option *ngFor="let p of AllPositions" [ngValue]="p.hid">
							{{p.name}}
						</option>
					</select>
				</div>
				<div class="col-md-1 column-title">
					<sort-column-header
						[column]="sortColumns.state"
						[(currentSorting)]="currentSorting"></sort-column-header>
					<div class="mt-1">
						<a title="Filter: status"
							href
							(click)="$event.preventDefault()"
							class="href-only-on-hover"
							[matMenuTriggerFor]="statusMenu">
								<i class="fa fa-fw fa-filter"></i>
								{{getSelectedFilterOptionsCount("state")}} of {{AllCaseStates.length}}
						</a>
					</div>

					<mat-menu #statusMenu="matMenu" formGroupName="state" overlapTrigger="false">
						<button mat-menu-item (click)="$event.stopPropagation(); toggleAllFilterOptions('state')">
							{{allFilterOptionsSelected('state') ? 'Deselect All' : 'Select All'}}
						</button>
						<hr style="margin: 4px 0;">
						<label
							*ngFor="let s of AllCaseStates; let index=index"
							mat-menu-item
							class="checkbox"
							style="display:block;"
							(click)="$event.stopPropagation()">
								<input type="checkbox" [formControl]="filterForm.controls['state'].controls[index]">
								{{s | caseState}}
						</label>
					</mat-menu>
				</div>
				<div class="col-md-2 column-title">
					<sort-column-header
						[column]="sortColumns.eligibleFor"
						[(currentSorting)]="currentSorting"></sort-column-header>
					<div class="mt-1">
						<a title="Filter: Eligible actions"
							href
							(click)="$event.preventDefault()"
							class="href-only-on-hover"
							[matMenuTriggerFor]="eligibilityMenu">
								<i class="fa fa-fw fa-filter"></i>
								{{getSelectedFilterOptionsCount("eligibility")}} of {{AllEligibleActions.length}}
						</a>
					</div>

					<mat-menu #eligibilityMenu="matMenu" formArrayName="eligibility" overlapTrigger="false">
						<button mat-menu-item (click)="$event.stopPropagation(); toggleAllFilterOptions('eligibility')">
							{{allFilterOptionsSelected('eligibility') ? 'Deselect All' : 'Select All'}}
						</button>
						<hr style="margin: 4px 0;">
						<label
							*ngFor="let at of AllEligibleActions; let index=index"
							mat-menu-item
							class="checkbox"
							style="display:block;"
							(click)="$event.stopPropagation()">
								<input type="checkbox" [formControl]="filterForm.controls['eligibility'].controls[index]">
								<span [ngSwitch]="at.hasValue()">
									<span *ngSwitchCase="true">
										{{at.value | actionTypeName}}
									</span>
								</span>
						</label>
					</mat-menu>
				</div>
				<div class="col-md-1 column-title">
					<sort-column-header
						[column]="sortColumns.proposed"
						[(currentSorting)]="currentSorting"></sort-column-header>
					<div class="mt-1">
						<a title="Filter: proposed action"
							href
							(click)="$event.preventDefault()"
							class="href-only-on-hover"
							[matMenuTriggerFor]="proposalMenu">
								<i class="fa fa-fw fa-filter"></i>
								{{getSelectedFilterOptionsCount("proposal")}} of {{AllProposals.length}}
						</a>
					</div>

					<mat-menu #proposalMenu="matMenu" overlapTrigger="false">
						<button mat-menu-item (click)="$event.stopPropagation(); toggleAllFilterOptions('proposal')">
							{{allFilterOptionsSelected('proposal') ? 'Deselect All' : 'Select All'}}
						</button>
						<hr style="margin: 4px 0;">
						<label
							*ngFor="let p of AllProposals; let index=index"
							mat-menu-item
							class="checkbox"
							style="display:block;"
							(click)="$event.stopPropagation()">
								<input type="checkbox" [formControl]="filterForm.controls['proposal'].controls[index]">
								<span [ngSwitch]="p.hasValue()">
									<span *ngSwitchCase="true">
										{{p.value | actionTypeName}}
									</span>
									<span *ngSwitchCase="false">
										None Yet
									</span>
								</span>
						</label>
						<hr style="margin: 4px 0;">
						<div mat-menu-item disabled class="menu-section-label">Exceptional Timing</div>
						<label
							*ngFor="let t of AllExceptionalTimings; let index=index"
							mat-menu-item
							class="checkbox"
							style="display:block;"
							(click)="$event.stopPropagation()">
								<input type="checkbox" [formControl]="filterForm.controls['exceptionalTiming'].controls[index]">
								{{t.label}}
						</label>
					</mat-menu>
				</div>
				<div class="col-md-1 column-title text-center">
					<sort-column-header class="float-left"
						[column]="sortColumns.programYear"
						[(currentSorting)]="currentSorting"></sort-column-header>
				</div>
				<div class="col-md-1 column-title text-center">
					<sort-column-header
						[column]="sortColumns.supervisorCount"
						[(currentSorting)]="currentSorting"></sort-column-header>
				</div>
				<div class="col-md-1 column-title">
					<sort-column-header
						[column]="sortColumns.userSeparated"
						[(currentSorting)]="currentSorting"></sort-column-header>
					<div class="mt-1">
						<a title="Filter: Academic Separation Status"
							href
							(click)="$event.preventDefault()"
							class="href-only-on-hover"
							[matMenuTriggerFor]="academicSeparationStatusMenu">
								<i class="fa fa-fw fa-filter"></i>
								{{getSelectedFilterOptionsCount("academicSeparationStatus")}} of {{AllAcademicSeparationStatus.length}}
						</a>
					</div>

					<mat-menu #academicSeparationStatusMenu="matMenu" formArrayName="academicSeparationStatus" overlapTrigger="false">
						<button mat-menu-item (click)="$event.stopPropagation(); toggleAllFilterOptions('academicSeparationStatus')">
							{{allFilterOptionsSelected('academicSeparationStatus') ? 'Deselect All' : 'Select All'}}
						</button>
						<hr style="margin: 4px 0;">
						<label
							*ngFor="let t of AllAcademicSeparationStatus; let index=index"
							mat-menu-item
							class="checkbox"
							style="display:block;"
							(click)="$event.stopPropagation()">
								<input type="checkbox" [formControl]="filterForm.controls['academicSeparationStatus'].controls[index]">
								{{t}}
						</label>
					</mat-menu>
				</div>
			</div>
		</div>
	</div>

	<!-- Data table rows definition -->
	<div class="list-group text-sm" style='overflow: scroll; height: 600px; overflow-x: hidden;'>
		<div class="list-group-item"
		*ngFor="let case of cases; let i = index;"
		[ngStyle]="i == 0 ? {'border-radius':0, 'border-top': 'none'} : {}">
			<div class="row">
				<div class="col-md-2">
					<a class="href" (click)="viewDetails(case)">{{case.userName}}</a>
					<span *ngIf="case.needsReconciliation" class="badge badge-danger ml-1" title="Reviewer tasks are out of sync">!</span>
				</div>
				<div class="col-md-3 text-xs">
					<ng-container *ngFor="let e of case.currentPosition.elements; let first = first;" >
						<span *ngIf="e.name!=='' && !first">/</span>
						<a
							href
							class="href-only-on-hover"
							(click)="filterPosition(e.hid); $event.preventDefault();">
								{{e.name}}
						</a>
					</ng-container>
					<span *ngIf="!!case.currentPosition.term">
						/ {{case.currentPosition.term}}
					</span>
				</div>
				<div class="col-md-1 text-xs">
					<a
						href
						class="href-only-on-hover" 
						(click)="filterForState(case.state); $event.preventDefault();">
							{{case.state | caseState}}
					</a>
				</div>
				<div *ngIf="isNonAcademic(case); else academicEligibility" class="col-md-2 text-xs">
					<a href
						class="href-only-on-hover" 
						(click)="filterEligibility('NotApplicable'); $event.preventDefault();">{{'NotApplicable' | actionTypeName}}</a>

				</div>
				<ng-template #academicEligibility>
					<div class="col-md-2 text-xs">
						<span *ngFor="let a of case.eligibleActions; let first = first;"><span [hidden]="first">, </span><a href
							class="href-only-on-hover" 
							(click)="filterEligibility(a.type); $event.preventDefault();">{{a.type | actionTypeName}}</a></span>
					</div>
				</ng-template>
				<div class="col-md-1 text-xs" [ngSwitch]="case.proposedAction.hasValue()">
					<div *ngSwitchCase="true">						
						<ng-container [ngSwitch]="IsIndefiniteStatusOnly(case)">
							<ng-container *ngSwitchCase="true">
								<a href
									class="href-only-on-hover" 
									(click)="filterForTerm(case.proposedAction.value.endingPosition.term); $event.preventDefault();"
								>Indefinite Status</a>
							</ng-container>
							<ng-container *ngSwitchCase="false">
								<a
									href
									class="href-only-on-hover" 
									(click)="filterForProposedAction(case.proposedAction.value.type); $event.preventDefault();"
								>{{case.proposedAction.value.type | actionTypeName}}</a> 
								<a *ngIf="!!case.proposedAction.value.exceptionalTiming.value"
									href
									class="href-only-on-hover" 
									(click)="filterForExceptionalTiming(case.proposedAction.value.exceptionalTiming.value); $event.preventDefault();"
								>({{exceptionalTimingLabel(case.proposedAction.value.exceptionalTiming.value)}})</a>
								<span *ngIf="indefiniteStatusProposed(case)">
									<a href
										class="href-only-on-hover" 
										(click)="filterForTerm(case.proposedAction.value.endingPosition.term); $event.preventDefault();"
									>(Indefinite Status)</a>
								</span>
							</ng-container>
						</ng-container>
					</div>
					<div *ngSwitchCase="false" class="text-muted">
						<div *ngIf="isNonAcademic(case); else NoneYet">
							<a
								href
								class="href-only-on-hover" 
								(click)="filterForProposedAction('NotApplicable'); $event.preventDefault();">
								N/A
							</a>
						</div>
						<ng-template #NoneYet>
							<a
								href
								class="href-only-on-hover" 
								(click)="filterForProposedAction(); $event.preventDefault();">
								None Yet
							</a>							
						</ng-template>
					</div>
				</div>

				<ng-container [ngSwitch]="isNonAcademic(case)">
					
					<ng-container *ngSwitchCase="true">
					  	<div class="col-md-1 text-center">
							—
					  	</div>
					  	<div class="col-md-1 text-center">
							—
					  	</div>
					</ng-container>
					
					<ng-container *ngSwitchDefault>
					  	<div class="col-md-1 text-center">
							{{case.year}}
					  	</div>
					  	<div class="col-md-1 text-center">
							{{case.supervisors.length}}
					  	</div>
					</ng-container>

				</ng-container>
				
				<div class="col-md-1 text-center">
					{{case.userSeparationDate ? (case.userSeparationDate | date:'MM/dd/yyyy') : "—"}}
				</div>
			</div>
		</div>
	</div>
</div>